var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGaphsPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 504,
    height: 590,
    viewBox: "0 0 504 590",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_39_899)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M389.92 579.71C354.59 580.18 245.12 582.1 178.7 587.11C55.53 596.4 -45.12 581.79 20.93 564.65C39.39 559.86 -13.95 531.57 116.43 524.82C230.89 518.9 347.61 530.68 404.09 535.71C460.58 540.75 486.66 549.88 498.77 553.99C509.42 557.61 513.4 578.06 389.91 579.7L389.92 579.71Z",
    fill: "#1FD5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.52 157.43H360.17V138.84H354.52V157.43Z",
    fill: "#C4E9F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.52 206.22H360.17V174.86H354.52V206.22Z",
    fill: "#C4E9F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.52 243.4H360.17V213.49H354.52V243.4Z",
    fill: "#C4E9F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.41 478.36C152.41 494.97 165.99 508.57 182.61 508.57H327.83C344.44 508.57 358.04 494.97 358.04 478.36V113.96C358.04 97.35 344.44 83.75 327.83 83.75H182.61C165.99 83.75 152.41 97.35 152.41 113.96V478.36Z",
    fill: "#C4E9F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.83 504.3C342.14 504.3 353.77 492.66 353.77 478.36V113.96C353.77 99.66 342.14 88.02 327.83 88.02H182.61C168.3 88.02 156.67 99.66 156.67 113.96V478.36C156.67 492.66 168.31 504.3 182.61 504.3H327.83Z",
    fill: "#1356DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.67 137.39H165.76V456.29H344.67V137.39Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.54 137.83H166.2V349.89H344.54V137.83Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.82 162.03H235.94V207.2H236.82V162.03Z",
    fill: "#00B8F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.6 176.22H233.15V191.71H239.6V176.22Z",
    fill: "#00B8F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.72 162.03H248.84V207.2H249.72V162.03Z",
    fill: "#00B8F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.5 171.71H246.05V187.2H252.5V171.71Z",
    fill: "#00B8F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.63 162.03H261.75V207.2H262.63V162.03Z",
    fill: "#00B8F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.41 176.22H258.96V191.71H265.41V176.22Z",
    fill: "#00B8F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.19 219.97H287.02V220.85H332.19V219.97Z",
    fill: "#00B8F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.79 242.48H193.78V213.64H267.79V242.48ZM194.66 241.61H266.91V214.52H194.66V241.61Z",
    fill: "#1356DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.35 220.96H194.22V221.84H267.35V220.96Z",
    fill: "#1356DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.47 219.25C197.72 219.25 197.12 218.64 197.12 217.9C197.12 217.16 197.73 216.55 198.47 216.55C199.21 216.55 199.82 217.16 199.82 217.9C199.82 218.64 199.21 219.25 198.47 219.25ZM198.47 217.42C198.21 217.42 197.99 217.63 197.99 217.9C197.99 218.17 198.2 218.38 198.47 218.38C198.74 218.38 198.95 218.17 198.95 217.9C198.95 217.63 198.74 217.42 198.47 217.42Z",
    fill: "#1356DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.09 219.25C202.34 219.25 201.74 218.64 201.74 217.9C201.74 217.16 202.35 216.55 203.09 216.55C203.83 216.55 204.44 217.16 204.44 217.9C204.44 218.64 203.83 219.25 203.09 219.25ZM203.09 217.42C202.83 217.42 202.61 217.63 202.61 217.9C202.61 218.17 202.82 218.38 203.09 218.38C203.36 218.38 203.57 218.17 203.57 217.9C203.57 217.63 203.36 217.42 203.09 217.42Z",
    fill: "#1356DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.71 219.25C206.96 219.25 206.36 218.64 206.36 217.9C206.36 217.16 206.97 216.55 207.71 216.55C208.45 216.55 209.06 217.16 209.06 217.9C209.06 218.64 208.45 219.25 207.71 219.25ZM207.71 217.42C207.45 217.42 207.23 217.63 207.23 217.9C207.23 218.17 207.44 218.38 207.71 218.38C207.98 218.38 208.19 218.17 208.19 217.9C208.19 217.63 207.98 217.42 207.71 217.42Z",
    fill: "#1356DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.96 226.93H200.72V227.81H258.96V226.93Z",
    fill: "#1356DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.96 231.44H200.72V232.32H258.96V231.44Z",
    fill: "#1356DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.96 235.96H200.72V236.84H258.96V235.96Z",
    fill: "#1356DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.16 222.15C282.2 222.15 281.42 221.37 281.42 220.41C281.42 219.45 282.2 218.67 283.16 218.67C284.12 218.67 284.9 219.45 284.9 220.41C284.9 221.37 284.12 222.15 283.16 222.15ZM283.16 219.54C282.68 219.54 282.29 219.93 282.29 220.41C282.29 220.89 282.68 221.28 283.16 221.28C283.64 221.28 284.03 220.89 284.03 220.41C284.03 219.93 283.64 219.54 283.16 219.54Z",
    fill: "#00B8F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.19 229.65H287.02V230.53H332.19V229.65Z",
    fill: "#00B8F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.16 231.83C282.2 231.83 281.42 231.05 281.42 230.09C281.42 229.13 282.2 228.35 283.16 228.35C284.12 228.35 284.9 229.13 284.9 230.09C284.9 231.05 284.12 231.83 283.16 231.83ZM283.16 229.22C282.68 229.22 282.29 229.61 282.29 230.09C282.29 230.57 282.68 230.96 283.16 230.96C283.64 230.96 284.03 230.57 284.03 230.09C284.03 229.61 283.64 229.22 283.16 229.22Z",
    fill: "#00B8F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.19 239.33H287.02V240.21H332.19V239.33Z",
    fill: "#00B8F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.16 241.51C282.2 241.51 281.42 240.73 281.42 239.77C281.42 238.81 282.2 238.03 283.16 238.03C284.12 238.03 284.9 238.81 284.9 239.77C284.9 240.73 284.12 241.51 283.16 241.51ZM283.16 238.9C282.68 238.9 282.29 239.29 282.29 239.77C282.29 240.25 282.68 240.64 283.16 240.64C283.64 240.64 284.03 240.25 284.03 239.77C284.03 239.29 283.64 238.9 283.16 238.9Z",
    fill: "#00B8F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.41 209.23C292.18 209.23 281.42 198.47 281.42 185.24C281.42 172.01 292.18 161.25 305.41 161.25C318.64 161.25 329.4 172.01 329.4 185.24C329.4 198.47 318.64 209.23 305.41 209.23ZM305.41 162.13C292.67 162.13 282.3 172.5 282.3 185.24C282.3 197.98 292.67 208.35 305.41 208.35C318.15 208.35 328.52 197.98 328.52 185.24C328.52 172.5 318.15 162.13 305.41 162.13Z",
    fill: "#00B8F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.96 185.69H304.98V161.25H305.42C318.64 161.25 329.4 172.02 329.4 185.24V185.68H328.96V185.69ZM305.86 184.82H328.52C328.29 172.42 318.25 162.37 305.86 162.14V184.82Z",
    fill: "#00B8F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.96 185.69H304.27L286.75 170.16L287.02 169.83C291.6 164.38 298.3 161.25 305.41 161.25C318.64 161.25 329.4 172.01 329.4 185.24V185.68H328.96V185.69ZM304.6 184.82H328.52C328.29 172.27 318.01 162.13 305.41 162.13C298.7 162.13 292.37 165.02 287.97 170.08L304.6 184.82Z",
    fill: "#00B8F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.75 269.99H202.01V270.87H204.75V269.99Z",
    fill: "#00B8F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.43 269.99H216.64V270.87H221.43V269.99Z",
    fill: "#00B8F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.03 269.99H237.07V270.87H245.03V269.99Z",
    fill: "#00B8F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.69 269.99H253.64V270.87H258.69V269.99Z",
    fill: "#00B8F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.54 275.23C194.89 275.23 192.74 273.08 192.74 270.43C192.74 267.78 194.89 265.63 197.54 265.63C200.19 265.63 202.34 267.78 202.34 270.43C202.34 273.08 200.19 275.23 197.54 275.23ZM197.54 266.5C195.38 266.5 193.62 268.26 193.62 270.42C193.62 272.58 195.38 274.34 197.54 274.34C199.7 274.34 201.46 272.58 201.46 270.42C201.46 268.26 199.7 266.5 197.54 266.5Z",
    fill: "#00B8F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.34 275.23C246.69 275.23 244.54 273.08 244.54 270.43C244.54 267.78 246.69 265.63 249.34 265.63C251.99 265.63 254.14 267.78 254.14 270.43C254.14 273.08 251.99 275.23 249.34 275.23ZM249.34 266.5C247.18 266.5 245.42 268.26 245.42 270.42C245.42 272.58 247.18 274.34 249.34 274.34C251.5 274.34 253.26 272.58 253.26 270.42C253.26 268.26 251.5 266.5 249.34 266.5Z",
    fill: "#00B8F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.44 274.48H221.11V266.38H237.44V274.48ZM221.99 273.6H236.57V267.25H221.99V273.6Z",
    fill: "#00B8F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.22 274.48H258.12V266.38H266.22V274.48ZM258.99 273.6H265.34V267.25H258.99V273.6Z",
    fill: "#00B8F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.44 277.25L203.62 270.43L210.44 263.61L217.26 270.43L210.44 277.25ZM204.86 270.43L210.44 276.01L216.02 270.43L210.44 264.85L204.86 270.43Z",
    fill: "#00B8F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.12 281.48H209.89V276.17L224.12 281.48ZM210.77 280.6H219.27L210.77 277.43V280.6Z",
    fill: "#00B8F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.89 264.68V259.37H224.12L209.89 264.68ZM210.77 260.25V263.42L219.27 260.25H210.77Z",
    fill: "#00B8F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.1 281.48H235.7L250.1 273.89V281.48ZM239.23 280.6H249.22V275.33L239.23 280.6Z",
    fill: "#00B8F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.1 266.97L235.7 259.38H250.1V266.97ZM239.23 260.25L249.22 265.52V260.25H239.23Z",
    fill: "#00B8F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.44 264.25H221.11V256.15H237.44V264.25ZM221.99 263.37H236.57V257.02H221.99V263.37Z",
    fill: "#00B8F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.44 284.71H221.11V276.61H237.44V284.71ZM221.99 283.83H236.57V277.48H221.99V283.83Z",
    fill: "#00B8F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.03 307.74H201.19V308.62H317.03V307.74Z",
    fill: "#00B8F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.03 297.41H201.19V298.29H317.03V297.41Z",
    fill: "#00B8F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.03 318.06H201.19V318.94H317.03V318.06Z",
    fill: "#00B8F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.03 328.39H201.19V329.27H317.03V328.39Z",
    fill: "#00B8F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.88 318.5C278.88 319.22 278.3 319.8 277.58 319.8C276.86 319.8 276.28 319.22 276.28 318.5C276.28 317.78 276.86 317.2 277.58 317.2C278.3 317.2 278.88 317.78 278.88 318.5Z",
    fill: "#00B8F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.57 320.25C276.61 320.25 275.83 319.47 275.83 318.51C275.83 317.55 276.61 316.77 277.57 316.77C278.53 316.77 279.31 317.55 279.31 318.51C279.31 319.47 278.53 320.25 277.57 320.25ZM277.57 317.64C277.09 317.64 276.7 318.03 276.7 318.51C276.7 318.99 277.09 319.38 277.57 319.38C278.05 319.38 278.44 318.99 278.44 318.51C278.44 318.03 278.05 317.64 277.57 317.64Z",
    fill: "#00B8F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.62 308.27C286.62 308.99 286.04 309.57 285.32 309.57C284.6 309.57 284.02 308.99 284.02 308.27C284.02 307.55 284.6 306.97 285.32 306.97C286.04 306.97 286.62 307.55 286.62 308.27Z",
    fill: "#00B8F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.32 310.01C284.36 310.01 283.58 309.23 283.58 308.27C283.58 307.31 284.36 306.53 285.32 306.53C286.28 306.53 287.06 307.31 287.06 308.27C287.06 309.23 286.28 310.01 285.32 310.01ZM285.32 307.4C284.84 307.4 284.45 307.79 284.45 308.27C284.45 308.75 284.84 309.14 285.32 309.14C285.8 309.14 286.19 308.75 286.19 308.27C286.19 307.79 285.8 307.4 285.32 307.4Z",
    fill: "#00B8F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.61 328.67C206.61 329.39 206.03 329.97 205.31 329.97C204.59 329.97 204.01 329.39 204.01 328.67C204.01 327.95 204.59 327.37 205.31 327.37C206.03 327.37 206.61 327.95 206.61 328.67Z",
    fill: "#00B8F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.31 330.41C204.35 330.41 203.57 329.63 203.57 328.67C203.57 327.71 204.35 326.93 205.31 326.93C206.27 326.93 207.05 327.71 207.05 328.67C207.05 329.63 206.27 330.41 205.31 330.41ZM205.31 327.8C204.83 327.8 204.44 328.19 204.44 328.67C204.44 329.15 204.83 329.54 205.31 329.54C205.79 329.54 206.18 329.15 206.18 328.67C206.18 328.19 205.79 327.8 205.31 327.8Z",
    fill: "#00B8F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.75 308.13C225.75 308.85 225.17 309.43 224.45 309.43C223.73 309.43 223.15 308.85 223.15 308.13C223.15 307.41 223.73 306.83 224.45 306.83C225.17 306.83 225.75 307.41 225.75 308.13Z",
    fill: "#00B8F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.45 309.87C223.49 309.87 222.71 309.09 222.71 308.13C222.71 307.17 223.49 306.39 224.45 306.39C225.41 306.39 226.19 307.17 226.19 308.13C226.19 309.09 225.41 309.87 224.45 309.87ZM224.45 307.26C223.97 307.26 223.58 307.65 223.58 308.13C223.58 308.61 223.97 309 224.45 309C224.93 309 225.32 308.61 225.32 308.13C225.32 307.65 224.93 307.26 224.45 307.26Z",
    fill: "#00B8F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.57 318.34C239.57 319.06 238.99 319.64 238.27 319.64C237.55 319.64 236.97 319.06 236.97 318.34C236.97 317.62 237.55 317.04 238.27 317.04C238.99 317.04 239.57 317.62 239.57 318.34Z",
    fill: "#00B8F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.27 320.08C237.31 320.08 236.53 319.3 236.53 318.34C236.53 317.38 237.31 316.6 238.27 316.6C239.23 316.6 240.01 317.38 240.01 318.34C240.01 319.3 239.23 320.08 238.27 320.08ZM238.27 317.48C237.79 317.48 237.4 317.87 237.4 318.35C237.4 318.83 237.79 319.22 238.27 319.22C238.75 319.22 239.14 318.83 239.14 318.35C239.14 317.87 238.75 317.48 238.27 317.48Z",
    fill: "#00B8F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.98 297.96C253.98 298.68 253.4 299.26 252.68 299.26C251.96 299.26 251.38 298.68 251.38 297.96C251.38 297.24 251.96 296.66 252.68 296.66C253.4 296.66 253.98 297.24 253.98 297.96Z",
    fill: "#00B8F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.68 299.7C251.72 299.7 250.94 298.92 250.94 297.96C250.94 297 251.72 296.22 252.68 296.22C253.64 296.22 254.42 297 254.42 297.96C254.42 298.92 253.64 299.7 252.68 299.7ZM252.68 297.1C252.2 297.1 251.81 297.49 251.81 297.97C251.81 298.45 252.2 298.84 252.68 298.84C253.16 298.84 253.55 298.45 253.55 297.97C253.55 297.49 253.16 297.1 252.68 297.1Z",
    fill: "#00B8F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.78 308.39C266.78 309.11 266.2 309.69 265.48 309.69C264.76 309.69 264.18 309.11 264.18 308.39C264.18 307.67 264.76 307.09 265.48 307.09C266.2 307.09 266.78 307.67 266.78 308.39Z",
    fill: "#00B8F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.48 310.14C264.52 310.14 263.74 309.36 263.74 308.4C263.74 307.44 264.52 306.66 265.48 306.66C266.44 306.66 267.22 307.44 267.22 308.4C267.22 309.36 266.44 310.14 265.48 310.14ZM265.48 307.53C265 307.53 264.61 307.92 264.61 308.4C264.61 308.88 265 309.27 265.48 309.27C265.96 309.27 266.35 308.88 266.35 308.4C266.35 307.92 265.96 307.53 265.48 307.53Z",
    fill: "#00B8F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.6 317.72L265.79 309.41L266.32 308.72L277.13 317.02L276.6 317.72Z",
    fill: "#00B8F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.391 308.931L206.446 327.475L207.095 328.068L224.04 309.524L223.391 308.931Z",
    fill: "#00B8F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.418 308.543L224.907 309.26L237.005 317.889L237.516 317.173L225.418 308.543Z",
    fill: "#00B8F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.741 298.89L239.075 317.196L239.798 317.696L252.464 299.391L251.741 298.89Z",
    fill: "#00B8F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.93 307.71L253.44 299.16L253.99 298.48L264.48 307.03L263.93 307.71Z",
    fill: "#00B8F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.14 297.94C309.14 298.66 308.56 299.24 307.84 299.24C307.12 299.24 306.54 298.66 306.54 297.94C306.54 297.22 307.12 296.64 307.84 296.64C308.56 296.64 309.14 297.22 309.14 297.94Z",
    fill: "#00B8F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.84 299.68C306.88 299.68 306.1 298.9 306.1 297.94C306.1 296.98 306.88 296.2 307.84 296.2C308.8 296.2 309.58 296.98 309.58 297.94C309.58 298.9 308.8 299.68 307.84 299.68ZM307.84 297.07C307.36 297.07 306.97 297.46 306.97 297.94C306.97 298.42 307.36 298.81 307.84 298.81C308.32 298.81 308.71 298.42 308.71 297.94C308.71 297.46 308.32 297.07 307.84 297.07Z",
    fill: "#00B8F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.345 309.092L278.045 317.316L278.744 317.851L285.044 309.627L284.345 309.092Z",
    fill: "#00B8F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.778 298.518L286.447 307.384L286.798 308.19L307.129 299.325L306.778 298.518Z",
    fill: "#00B8F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.35 339.06H181.62V444.74H326.35V339.06Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.41 387.55H202.49V429.99H205.41V387.55Z",
    fill: "#00B8F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.689 347.73L189.42 347.998L198.224 356.802L198.493 356.533L189.689 347.73Z",
    fill: "#1356DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.224 347.747L189.42 356.55L189.689 356.819L198.493 348.015L198.224 347.747Z",
    fill: "#1356DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.41 404.02H202.49V430H205.41V404.02Z",
    fill: "#1356DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.12 387.55H217.2V429.99H220.12V387.55Z",
    fill: "#00B8F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.12 410.75H217.2V429.99H220.12V410.75Z",
    fill: "#00DAAB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.83 387.55H231.91V429.99H234.83V387.55Z",
    fill: "#00B8F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.83 396.31H231.91V429.99H234.83V396.31Z",
    fill: "#1356DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.54 387.55H246.62V429.99H249.54V387.55Z",
    fill: "#00B8F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.54 410.75H246.62V429.99H249.54V410.75Z",
    fill: "#00DAAB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.25 387.55H261.33V429.99H264.25V387.55Z",
    fill: "#00B8F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.25 404.02H261.33V430H264.25V404.02Z",
    fill: "#1356DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.96 387.55H276.04V429.99H278.96V387.55Z",
    fill: "#00B8F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.96 409.43H276.04V430H278.96V409.43Z",
    fill: "#00DAAB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.67 387.55H290.75V429.99H293.67V387.55Z",
    fill: "#00B8F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.67 398.97H290.75V430H293.67V398.97Z",
    fill: "#1356DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.38 387.55H305.46V429.99H308.38V387.55Z",
    fill: "#00B8F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.38 391.18H305.46V429.99H308.38V391.18Z",
    fill: "#00DAAB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.47 368.28V365.18H202.49V368.28H228.47Z",
    fill: "#00B8F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.93 374.82V371.72H202.49V374.82H244.93Z",
    fill: "#00DAAB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.76 137.39V456.27H344.98V137.39H165.76ZM344.11 331.75V448.18V455.39H166.64V138.27H344.11V331.76V331.75Z",
    fill: "#00B8F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.49 247.59H277.25V310.05H348.49V247.59Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.97 310.53H276.76V247.11H348.97V310.53ZM277.73 309.56H348V248.07H277.73V309.56Z",
    fill: "#1356DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.05 258.3H278.68V268.35H347.05V258.3Z",
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.05 278.54H278.68V288.59H347.05V278.54Z",
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.05 298.78H278.68V308.83H347.05V298.78Z",
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.97 258.03H276.76V247.1H348.97V258.03ZM277.73 257.06H348V248.07H277.73V257.06Z",
    fill: "#1356DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.67 252.08H282.87V253.05H306.67V252.08Z",
    fill: "#1356DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.71 252.08H330.18V253.05H334.71V252.08Z",
    fill: "#1356DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.39 252.08H338.86V253.05H343.39V252.08Z",
    fill: "#1356DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.46 262.81H282.87V263.78H313.46V262.81Z",
    fill: "#1356DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.71 262.81H330.18V263.78H334.71V262.81Z",
    fill: "#1356DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.39 262.81H338.86V263.78H343.39V262.81Z",
    fill: "#1356DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.64 272.99H282.87V273.96H307.64V272.99Z",
    fill: "#1356DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.71 272.99H330.18V273.96H334.71V272.99Z",
    fill: "#1356DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.39 272.99H338.86V273.96H343.39V272.99Z",
    fill: "#1356DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.22 283.17H282.87V284.14H321.22V283.17Z",
    fill: "#1356DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.71 283.17H330.18V284.14H334.71V283.17Z",
    fill: "#1356DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.39 283.17H338.86V284.14H343.39V283.17Z",
    fill: "#1356DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.46 293.36H282.87V294.33H313.46V293.36Z",
    fill: "#1356DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.71 293.36H330.18V294.33H334.71V293.36Z",
    fill: "#1356DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.39 293.36H338.86V294.33H343.39V293.36Z",
    fill: "#1356DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.46 303.54H282.87V304.51H313.46V303.54Z",
    fill: "#1356DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.71 303.54H330.18V304.51H334.71V303.54Z",
    fill: "#1356DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.39 303.54H338.86V304.51H343.39V303.54Z",
    fill: "#1356DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.35 0H178.88V111.2H261.35V0Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.65 390.22C164.15 392.36 179.81 399.97 183.09 413C188.01 432.56 178.16 461.27 193.75 489.35C198.73 498.3 107.62 510.33 107.62 510.33L90.04 411.51C90.04 411.51 112 390.06 116.49 388.62C125.79 385.63 138.66 385.95 155.64 390.22H155.65Z",
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.9 411.57C86.73 419.47 78.75 466.45 87.66 477.52C88.69 478.79 83.04 480.79 84.06 486.63C84.23 487.61 85.94 492.27 85.94 492.27L93.22 494.17L115.22 481.64L111 476.51L109.01 476.55C109.01 476.55 107.13 474.79 107.65 472.64C108.17 470.49 102.6 466.98 94.18 430.53C91.71 419.8 90.6 409.82 89.9 411.56V411.57Z",
    fill: "#C4E9F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.41 475.3L104.92 473.87L107.55 473.45C107.57 475.24 109 476.57 109 476.57L103.95 476.73L98.04 478L90.9 482.07L98.41 475.31V475.3Z",
    fill: "#F8CF5C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.72 481.37C107.72 481.37 102.69 481.31 98.4 483.95C95.14 485.96 92.14 490.33 95.13 492.69C98.13 495.06 102.75 497.26 102.75 497.26C102.75 497.26 114.2 497.57 107.71 481.37H107.72Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.15 492.85L98.22 492.19C98.22 492.19 108.77 491.24 110.27 492.06C111.77 492.89 116.61 496.16 116.61 496.16L117.61 497.08C117.61 497.08 115.26 498.55 112.08 496.32C108.9 494.1 108.63 495.81 108.63 495.81L109.16 498.62L109.12 502.22L109.61 503.73C109.61 503.73 110.05 504.55 109.7 504.85C108.7 505.73 107.7 505.31 107.7 505.31L104.48 499.7L103.61 505.8C103.61 505.8 103.18 506.62 102.17 506.84C101.23 507.04 101.22 506.79 101.22 506.79L100.5 505.23C100.42 505.56 100.25 505.99 99.86 506.3C99.06 506.92 97.94 506.84 97.94 506.84L98.24 500.42L96.92 503.68C96.92 503.68 96.45 504.49 95.48 504.72C94.41 504.98 94.13 505.05 94.13 505.05L95.13 492.84L95.15 492.85Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.81 467.74C149.81 467.74 142.14 487.15 123.74 492.34C120.55 493.24 118.6 496.68 120.14 497.78C122.1 499.2 124.8 499.51 129.42 499.49C139.04 499.46 152.14 496.48 161.2 487.71C174.61 474.73 178.84 468.83 177.48 462.3C176.13 455.77 149.81 467.74 149.81 467.74Z",
    fill: "#F7B68B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.48 406.47C184.37 412.88 186.63 423.17 186.6 437.89C186.57 449.28 176.74 467.94 175.23 473.68C174.98 474.64 174.38 478.74 174.38 478.74L163.48 489.43L141.63 474.62L148.27 464.42L150.25 464.63C150.25 464.63 151.51 459.01 151.17 456.82C150.83 454.63 157.22 425.24 160.39 406.39C162.21 395.53 176.61 400.12 180.48 406.47Z",
    fill: "#C4E9F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.91 464.26L154.54 462.28L151.95 461.64C151.79 463.42 150.24 464.62 150.24 464.62L155.26 465.2L161.04 466.97L167.81 471.63L160.9 464.26H160.91Z",
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.14 492.27L114.01 489.22C114.01 489.22 110.85 493.45 111.46 494.51C112.06 495.56 111.46 501.82 111.46 501.82L116.85 506.4L121.24 504.94C121.24 504.94 121.54 503.03 120.04 502.85C118.54 502.66 121.06 501.57 121.84 501.12C122.63 500.67 129.08 497.34 125.15 492.27H125.14Z",
    fill: "#F7B68B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.1 386.14C142.94 391.4 140.15 397.2 134.89 399.05L134.84 399.07C129.58 400.91 123.78 398.12 121.94 392.86L118.52 383.09C116.68 377.83 119.47 372.03 124.73 370.18L124.78 370.16C130.04 368.32 135.84 371.11 137.69 376.37L141.11 386.14H141.1Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.64 403.39C115.28 405.72 117.7 407.09 120.04 406.45L139.1 401.2C141.44 400.56 142.81 398.14 142.17 395.8L134.39 367.57C133.74 365.24 131.33 363.86 128.99 364.51L109.94 369.76C107.6 370.4 106.23 372.82 106.87 375.16L114.65 403.39H114.64Z",
    fill: "#F7B68B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.44 380.98C108.44 380.98 105.13 378.95 104.19 377.4C103.72 376.62 103.67 373.18 105.44 371.36C107.22 369.54 109.61 371.36 109.61 371.36C109.61 371.36 106.75 374.17 106.77 374.93C106.79 375.68 108.44 380.98 108.44 380.98Z",
    fill: "#243C53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.83 379.73C139.83 379.73 139.72 368.08 138.31 365.06C136.9 362.02 135.94 359.92 131.96 360.63C126.01 361.71 126.28 362.96 122.97 361.97C119.66 360.98 113.41 358.13 111.55 358.19C108.44 358.28 104.15 360.51 105.49 366.03C106.47 370.1 104.2 371.8 104.31 371.92C104.67 372.35 105.87 372.53 107.97 372.94C113.99 374.13 117.32 373.79 121.08 371.61C124.85 369.44 131.77 365.06 133.48 367.81C135.19 370.58 137.37 379.84 137.91 380.45C138.46 381.06 139.27 380.45 139.83 379.73Z",
    fill: "#243C53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.16 389.86C136.37 390.64 137.18 391.1 137.96 390.88L142.08 389.74C142.86 389.53 143.32 388.72 143.1 387.94L141.02 380.41C140.8 379.63 140 379.18 139.22 379.39L135.1 380.52C134.33 380.73 133.86 381.55 134.08 382.32L136.15 389.85L136.16 389.86Z",
    fill: "#F7B68B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.6 396.62C111.82 397.4 112.62 397.86 113.41 397.64L117.52 396.51C118.3 396.29 118.76 395.49 118.55 394.71L116.48 387.17C116.26 386.39 115.45 385.93 114.68 386.15L110.56 387.28C109.78 387.5 109.33 388.3 109.54 389.08L111.61 396.61L111.6 396.62Z",
    fill: "#F7B68B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.68 382.71C138.68 382.71 141.75 393.83 142.77 397.53C143.69 400.88 144.38 408.6 125.46 413.82C114.26 416.9 112.4 408.55 111.65 405.85C111.09 403.79 111.71 396.98 112.57 395.48C112.59 395.43 113.83 400.06 113.83 400.06C113.83 400.06 114.93 394.95 120.25 393.48C128.84 391.12 132.18 395.6 135.94 394.47C138.83 393.59 139.72 388.24 138.67 382.7L138.68 382.71Z",
    fill: "#243C53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.8 399.8L119.92 401.42C119.14 401.63 118.33 401.17 118.12 400.4L117.89 399.58L126.59 397.18L126.82 398.01C127.03 398.79 126.57 399.59 125.79 399.8H125.8Z",
    fill: "#F7B68B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.84 512.54C35.55 520.04 83.09 547.64 99.02 546L147.03 548.29C187.87 543.31 207.19 479.86 207.19 479.86C205.56 463.93 165.33 487.02 151 494.18C128.29 505.51 113.93 506.08 113.93 506.08C98.74 507.64 81.13 495.92 61.96 495.51C40.9 495.06 28.56 500.72 32.83 512.53L32.84 512.54Z",
    fill: "#243C53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.3 504.92C137.3 504.92 137.33 504.88 137.34 504.86V502.86L54.69 501.36L54.65 503.35C54.65 503.35 54.64 503.39 54.65 503.42L54.86 503.79C55.89 505.54 57.79 505.89 59.97 505.93L131.89 507.24C134.07 507.28 135.98 507.01 137.08 505.29L137.3 504.92Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.38 504.89C117.38 504.89 117.38 504.93 117.38 504.94L117.58 505.25C117.9 505.7 118.3 506.03 118.77 506.29L131.34 506.52C133.44 506.56 135.27 506.35 136.32 504.96L136.53 504.66C136.53 504.66 136.55 504.63 136.57 504.61V503.63L117.41 503.29L117.38 504.9V504.89Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.9569 501.98L64.9313 503.39L106.235 504.14L106.26 502.73L64.9569 501.98Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.96 502.43L106.99 461.61C106.73 460.54 105.64 459.64 104.57 459.62L46.58 458.56C45.51 458.54 44.85 459.4 45.12 460.47L55.1 501.29L116.96 502.42V502.43Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.56 480.54C85.07 482.62 83.8 484.29 81.73 484.25C79.66 484.21 77.57 482.48 77.06 480.41C76.55 478.32 77.83 476.66 79.9 476.7C81.97 476.73 84.07 478.45 84.57 480.54H84.56Z",
    fill: "#243C53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.38 558.87C148.66 559.86 144.3 553.21 144.3 553.21L129.52 541.58L132.64 533.71L161.42 546.65C161.42 546.65 160.1 557.89 154.38 558.87Z",
    fill: "#F7B68B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.28 552.75C144.28 552.75 144.27 553.44 145.37 556.47C146.47 559.5 147.82 560.56 149.25 560.99C154.76 562.61 158.74 561.79 172.01 564.35C185.28 566.9 189.26 564.97 193.14 558.86C197.03 552.74 192.99 547.94 186.52 547.45C177.15 546.74 171.94 547.81 167.06 547.06C161.94 546.29 161.62 545.14 158.64 543.31C155.83 541.58 153.25 551.85 155.9 554.22C158.24 556.32 146.27 556.64 144.27 552.75H144.28Z",
    fill: "#C4E9F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.12 558.66C152.63 560.28 156.62 559.46 169.88 562.02C183.15 564.57 187.13 562.64 191.01 556.53C192.81 553.7 192.89 551.18 191.84 549.21C194.76 551.22 195.76 554.73 193.13 558.86C189.25 564.97 185.27 566.9 172 564.35C158.73 561.79 154.76 562.61 149.24 560.99C148.14 560.66 147.09 559.94 146.16 558.26C146.47 558.43 146.79 558.56 147.12 558.67V558.66Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.3 552.94C144.28 552.81 144.28 552.75 144.28 552.75C144.32 552.82 144.37 552.89 144.41 552.96C144.37 552.96 144.34 552.95 144.3 552.94Z",
    fill: "#F7B68B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.96 557.54C173.39 557.69 173.77 556.89 173.9 555.77C174.15 553.48 174.66 551.19 175.43 548.93C175.81 547.81 175.8 546.82 175.34 546.69C174.87 546.57 174.12 547.37 173.76 548.46C173.03 550.69 172.54 552.96 172.31 555.22C172.2 556.33 172.53 557.37 172.96 557.54Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.85 556.79C169.31 556.88 169.71 556.1 169.83 555.03C170.08 552.9 170.58 550.74 171.35 548.6C171.73 547.55 171.7 546.64 171.21 546.57C170.72 546.52 169.95 547.3 169.59 548.35C168.86 550.47 168.39 552.6 168.16 554.71C168.05 555.76 168.41 556.67 168.85 556.78V556.79Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.54 556.59C165.01 556.66 165.47 555.83 165.64 554.73C165.99 552.53 166.58 550.31 167.44 548.09C167.86 547.01 167.86 546.09 167.34 546.07C166.83 546.04 166.01 546.89 165.6 547.97C164.78 550.17 164.21 552.36 163.9 554.54C163.75 555.62 164.07 556.54 164.54 556.6V556.59Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.37 539.88C153.37 539.88 51.81 498.12 46.01 498.06C26.4 497.88 30.9 517.73 40.83 527.07C52.55 538.09 141.72 558.25 141.72 558.25L153.37 539.88Z",
    fill: "#1356DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.09 547.13L140.81 520.84L129 509.14L98.72 540.96L113.09 547.13Z",
    fill: "#F7B68B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.34 526.46C107.34 526.46 177.9 461.79 182.66 459.86C198.76 453.32 208.74 471.11 208.18 477.25C207.44 485.22 135.76 549.99 135.76 549.99L107.34 526.46Z",
    fill: "#1356DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.53 549.18C63.88 550.71 63.59 555.19 63.59 555.19C63.59 555.19 87.14 564.1 95.41 564.26C97.56 564.31 101.43 563.44 105.13 562.41C105.75 562.24 107.19 560.63 107.79 560.45C108.92 560.12 109.18 561.22 110.15 560.91C112.65 560.11 114.44 559.43 114.51 559.3C119.48 548.72 117.8 543.52 117.8 543.52C117.8 543.52 106.98 546.62 108.84 544.2C112.81 539.02 101.47 533.71 98.94 536.47C88.86 547.51 70.31 544.78 65.54 549.18H65.53Z",
    fill: "#C4E9F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.22 551.38C71.46 554.26 86.66 560.2 89.69 560.4C102.08 561.28 110.75 556.88 116.53 554.29C116.02 555.8 115.37 557.46 114.51 559.3C114.44 559.43 112.66 560.11 110.15 560.91C109.18 561.22 108.92 560.12 107.79 560.45C107.19 560.63 105.75 562.24 105.13 562.41C101.43 563.44 97.56 564.3 95.41 564.26C87.14 564.1 63.59 555.19 63.59 555.19C63.59 555.19 63.65 553.16 64.22 551.38Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.86 544.52C80.65 544.93 81.56 545.41 82.89 545.69C85.57 546.23 88.23 547.04 90.84 548.1C92.14 548.63 93.3 548.75 93.48 548.3C93.65 547.85 92.77 547 91.49 546.49C88.91 545.47 86.27 544.68 83.62 544.17C82.32 543.91 81.07 544.12 80.85 544.52H80.86Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.14 542.66C85.95 543.08 86.85 543.67 88.13 544.04C90.73 544.8 93.31 545.81 95.82 547.06C97.05 547.68 98.19 547.88 98.35 547.41C98.51 546.94 97.66 546 96.44 545.4C93.95 544.18 91.4 543.2 88.82 542.48C87.55 542.13 86.34 542.25 86.15 542.66H86.14Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.23 541.02C91.04 541.46 91.92 542.14 93.17 542.61C95.69 543.56 98.17 544.77 100.58 546.21C101.77 546.92 102.85 547.18 103 546.69C103.16 546.21 102.34 545.17 101.17 544.48C98.77 543.07 96.32 541.9 93.82 540.98C92.58 540.52 91.42 540.58 91.23 541.02Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.22 26.0701C214.22 33.2301 208.41 39.0401 201.25 39.0401C194.09 39.0401 188.28 33.2301 188.28 26.0701C188.28 18.9101 194.09 13.1001 201.25 13.1001C208.41 13.1001 214.22 18.9101 214.22 26.0701Z",
    fill: "#00B8F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.59 22.53H217.68V24.05H247.59V22.53Z",
    fill: "#1356DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.26 30.8501L193.73 26.3201L211.53 17.5801L198.26 30.8501ZM196.31 26.7501L198.27 28.7101L204 22.9801L196.32 26.7501H196.31Z",
    fill: "#1356DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.22 56.19C214.22 63.35 208.41 69.16 201.25 69.16C194.09 69.16 188.28 63.35 188.28 56.19C188.28 49.03 194.09 43.22 201.25 43.22C208.41 43.22 214.22 49.03 214.22 56.19Z",
    fill: "#00B8F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.59 52.6399H217.68V54.1599H247.59V52.6399Z",
    fill: "#1356DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.26 60.97L193.73 56.4399L211.53 47.7L198.26 60.97ZM196.31 56.86L198.27 58.81L204 53.08L196.32 56.8499L196.31 56.86Z",
    fill: "#1356DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.22 86.3001C214.22 93.4601 208.41 99.2701 201.25 99.2701C194.09 99.2701 188.28 93.4601 188.28 86.3001C188.28 79.1401 194.09 73.3301 201.25 73.3301C208.41 73.3301 214.22 79.1401 214.22 86.3001Z",
    fill: "#00B8F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.59 82.76H217.68V84.28H247.59V82.76Z",
    fill: "#1356DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.61 28.0901H217.68V29.6101H234.61V28.0901Z",
    fill: "#1356DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.61 58.2H217.68V59.72H234.61V58.2Z",
    fill: "#1356DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.61 88.3201H217.68V89.8401H234.61V88.3201Z",
    fill: "#1356DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.26 91.0801L193.73 86.5501L211.53 77.8101L198.26 91.0801ZM196.31 86.9801L198.27 88.9301L204 83.2001L196.32 86.9701L196.31 86.9801Z",
    fill: "#1356DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.92 158.51H189.98C192.17 158.51 193.95 160.29 193.95 162.48V253.7C193.95 255.89 192.17 257.67 189.98 257.67H80.92C78.73 257.67 76.95 255.89 76.95 253.7V162.48C76.95 160.29 78.73 158.51 80.92 158.51Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.98 256.9H80.92V258.42H189.98V256.9Z",
    fill: "#1356DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.95 174.56V159.7C193.95 159.05 192.17 158.51 189.98 158.51H80.92C78.73 158.51 76.95 159.04 76.95 159.7V174.56H193.95Z",
    fill: "#00B8F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.7 173.61H76.19V162.48C76.19 159.87 78.31 157.75 80.92 157.75H189.98C192.58 157.75 194.7 159.87 194.7 162.48V173.61ZM77.71 172.1H193.19V162.48C193.19 160.71 191.75 159.27 189.98 159.27H80.92C79.15 159.27 77.71 160.71 77.71 162.48V172.1Z",
    fill: "#1356DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.31 196.94H121.86V187.49H131.31V196.94ZM123.37 195.42H129.79V189.01H123.37V195.42Z",
    fill: "#1356DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.17 196.94H137.72V187.49H147.17V196.94ZM139.24 195.42H145.66V189.01H139.24V195.42Z",
    fill: "#1356DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.03 196.94H153.58V187.49H163.03V196.94ZM155.1 195.42H161.51V189.01H155.1V195.42Z",
    fill: "#1356DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.9 196.94H169.45V187.49H178.9V196.94ZM170.97 195.42H177.38V189.01H170.97V195.42Z",
    fill: "#1356DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.58 212.8H90.13V203.35H99.58V212.8ZM91.65 211.29H98.06V204.87H91.65V211.29Z",
    fill: "#1356DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.44 212.8H105.99V203.35H115.44V212.8ZM107.51 211.29H113.92V204.87H107.51V211.29Z",
    fill: "#1356DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.55 204.11H122.62V212.04H130.55V204.11Z",
    fill: "#FF5A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.41 204.11H138.48V212.04H146.41V204.11Z",
    fill: "#FF5A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.27 204.11H154.34V212.04H162.27V204.11Z",
    fill: "#FF5A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.9 212.8H169.45V203.35H178.9V212.8ZM170.97 211.29H177.38V204.87H170.97V211.29Z",
    fill: "#1356DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.82 219.98H90.89V227.91H98.82V219.98Z",
    fill: "#00B8F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.68 219.98H106.75V227.91H114.68V219.98Z",
    fill: "#00B8F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.31 228.67H121.86V219.22H131.31V228.67ZM123.37 227.15H129.79V220.73H123.37V227.15Z",
    fill: "#1356DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.17 228.67H137.72V219.22H147.17V228.67ZM139.24 227.15H145.66V220.73H139.24V227.15Z",
    fill: "#1356DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.03 228.67H153.58V219.22H163.03V228.67ZM155.1 227.15H161.51V220.73H155.1V227.15Z",
    fill: "#1356DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.9 228.67H169.45V219.22H178.9V228.67ZM170.97 227.15H177.38V220.73H170.97V227.15Z",
    fill: "#1356DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.58 244.53H90.13V235.08H99.58V244.53ZM91.65 243.01H98.06V236.6H91.65V243.01Z",
    fill: "#1356DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.44 244.53H105.99V235.08H115.44V244.53ZM107.51 243.01H113.92V236.6H107.51V243.01Z",
    fill: "#1356DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.31 244.53H121.86V235.08H131.31V244.53ZM123.37 243.01H129.79V236.6H123.37V243.01Z",
    fill: "#1356DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.84 191.46H92.87V192.98H96.84V191.46Z",
    fill: "#1356DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.7 191.46H108.73V192.98H112.7V191.46Z",
    fill: "#1356DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.16 239.05H172.19V240.57H176.16V239.05Z",
    fill: "#1356DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.3 239.05H156.33V240.57H160.3V239.05Z",
    fill: "#1356DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.43 239.05H140.46V240.57H144.43V239.05Z",
    fill: "#1356DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.27 165.69H120.58V167.21H156.27V165.69Z",
    fill: "#1356DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.84 165.69H84.88V167.21H88.84V165.69Z",
    fill: "#1356DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.02 165.69H182.05V167.21H186.02V165.69Z",
    fill: "#1356DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.95 173.62H76.95V175.14H193.95V173.62Z",
    fill: "#1356DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.89 231.92L396.99 225.06L398.61 223.24C394.57 219.01 392.08 213.29 392.08 206.99C392.08 200.73 394.52 194.83 398.95 190.38C403.4 185.91 409.32 183.44 415.61 183.44C421.89 183.44 427.81 185.88 432.26 190.35C436.72 194.8 439.17 200.71 439.17 206.99C439.17 213.1 436.85 218.86 432.61 223.27L434.21 225.07L440.32 231.94C440.38 231.88 440.45 231.82 440.51 231.76C447.13 225.12 450.76 216.33 450.76 206.99C450.76 197.63 447.09 188.8 440.45 182.17C433.8 175.52 424.99 171.87 415.61 171.87C406.22 171.87 397.4 175.55 390.75 182.22C384.13 188.86 380.49 197.66 380.49 207.01C380.49 216.75 384.47 225.57 390.89 231.94V231.92Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.62 223.26L434.22 225.06L440.33 231.93C440.39 231.87 440.46 231.81 440.52 231.75C447.14 225.11 450.77 216.32 450.77 206.98C450.77 200.9 449.21 195.04 446.3 189.86L439.27 193.83L436.22 195.56C438.15 199.02 439.18 202.92 439.19 206.98C439.19 213.09 436.87 218.85 432.63 223.26H432.62Z",
    fill: "#F8CF5C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.06 174.07H415.54V180.08H417.06V174.07Z",
    fill: "#1356DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.638 177.64L399.321 178.399L402.317 183.597L403.634 182.838L400.638 177.64Z",
    fill: "#1356DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.64 193.24L387.44 190.24L388.2 188.92L393.4 191.92L392.64 193.24Z",
    fill: "#1356DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.08 204.93H383.08V206.45H389.08V204.93Z",
    fill: "#1356DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.843 218.321L386.641 221.33L387.401 222.646L392.604 219.637L391.843 218.321Z",
    fill: "#1356DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.343 219.716L437.583 221.032L442.789 224.036L443.548 222.72L438.343 219.716Z",
    fill: "#1356DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.91 206.52H441.91V208.04H447.91V206.52Z",
    fill: "#1356DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.581 190.295L438.387 193.299L439.148 194.615L444.342 191.611L443.581 190.295Z",
    fill: "#1356DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.549 196.456L419.68 203.319L420.441 204.635L432.31 197.771L431.549 196.456Z",
    fill: "#1356DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.747 178.437L428.738 183.64L430.054 184.401L433.062 179.198L431.747 178.437Z",
    fill: "#1356DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.63 212.58C414.14 212.58 412.74 212 411.68 210.94C410.62 209.88 410.04 208.48 410.04 206.98C410.04 205.48 410.62 204.08 411.68 203.03C413.77 200.91 417.48 200.9 419.59 203.02C420.65 204.08 421.23 205.48 421.23 206.97C421.23 208.46 420.65 209.86 419.6 210.92C418.54 211.98 417.14 212.57 415.64 212.57L415.63 212.58ZM415.63 202.91C414.54 202.91 413.51 203.34 412.75 204.11C411.98 204.88 411.56 205.9 411.56 206.98C411.56 208.06 411.99 209.09 412.76 209.86C413.53 210.63 414.55 211.04 415.64 211.05C416.73 211.05 417.76 210.62 418.53 209.84C419.3 209.07 419.72 208.05 419.72 206.97C419.72 205.89 419.29 204.86 418.52 204.09C417.75 203.32 416.73 202.9 415.64 202.9L415.63 202.91Z",
    fill: "#1356DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.88 111.2H369.53V122.35H462.88V111.2Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.06 111.2H369.53V122.35H437.06V111.2Z",
    fill: "#FF5A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.82 106.32H436.3V127.22H437.82V106.32Z",
    fill: "#1356DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.88 141.85H369.53V153H462.88V141.85Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.34 141.85H369.53V153H396.34V141.85Z",
    fill: "#00DAAB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.1 136.97H396.58V157.87H398.1V136.97Z",
    fill: "#1356DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.24 354.65L334.1 333.68C334.1 333.68 328.05 334.99 331.39 338.37C334.73 341.74 356.45 361.29 356.45 361.29C356.45 361.29 376.89 367.44 369.23 354.65H369.24Z",
    fill: "#F7B68B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.42 340.06C335.42 340.06 328.72 338.35 325.36 337.66C322.01 336.97 312.96 333.58 311.63 332.23L310.29 330.88L318.84 333.27L315.83 330.74C315.83 330.74 310.8 329.37 310.13 328.87C309.46 328.36 309.13 327.52 309.13 327.52C308.3 325.84 309.31 325.51 309.31 325.51L315.68 326.71L320.37 328.58L317.53 325.55C317.53 325.55 312.16 324.85 311.66 324.35C311.16 323.84 311.5 322.67 311.5 322.67L319.04 323.88L326.06 328.78C326.06 328.78 326.57 327.78 325.06 326.59C323.56 325.41 322.89 324.23 322.89 323.39C322.89 322.55 327.24 325.76 327.91 326.6C328.58 327.44 332.77 328.8 333.92 332.5C335.08 336.2 335.39 340.06 335.39 340.06H335.42Z",
    fill: "#F7B68B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.24 354.65L334.1 333.68C334.1 333.68 328.05 334.99 331.39 338.37C334.73 341.74 356.45 361.29 356.45 361.29C356.45 361.29 376.89 367.44 369.23 354.65H369.24Z",
    fill: "#F7B68B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.54 292.39C412.54 292.39 407.81 299.85 402.64 300.25C397.48 300.64 394.89 288.47 394.89 280.22C394.89 271.97 403.93 264.12 404.79 261.76C405.65 259.4 414.69 267.26 414.69 274.33C414.69 281.4 412.54 290.43 412.54 292.4V292.39Z",
    fill: "#F7B68B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.32 549.58C444.32 549.58 444.77 553.94 444.77 555.28C444.77 556.62 441.86 560.43 441.64 561.54L441.42 562.66H463.34C463.34 562.66 463.79 560.42 460.21 557.51C456.63 554.6 455.51 552.59 455.06 548.9C454.61 545.21 444.32 549.57 444.32 549.57V549.58Z",
    fill: "#1356DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.95 550.14L408.19 562.22H373.96C373.96 562.22 373.74 558.42 377.76 557.3C381.79 556.18 392.75 552.83 395.66 549.25C398.57 545.67 405.95 550.14 405.95 550.14Z",
    fill: "#1356DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.23 549.24L411.67 428.77L406.64 376.42V373.4L425.77 373.74C425.77 373.74 437.85 386.83 437.51 403.94C437.17 421.05 436.5 459.64 439.19 467.03C441.87 474.41 448.92 486.83 449.59 494.55C450.26 502.27 453.62 548.58 453.62 548.58L445.23 549.25V549.24Z",
    fill: "#243C53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.5 374.08C386.5 374.08 379.79 385.49 381.47 405.62C383.15 425.75 396.23 548.57 396.23 548.57L406.3 548.91C406.3 548.91 409.66 501.93 408.31 490.52C406.97 479.11 403.28 467.37 403.61 465.35C403.95 463.34 424.35 406.06 420.72 395.89C418.86 390.68 412.67 374.08 411.66 373.74C410.65 373.4 386.49 374.08 386.49 374.08H386.5Z",
    fill: "#1356DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.24 540.57L396.13 511.04C394.59 494.12 392.4 474.53 390.2 464.83C386.2 447.17 386.8 383.48 386.83 380.78L388.2 380.74L397.51 511.13C398.78 525.17 399.61 537.35 399.61 540.51L398.24 540.56V540.57ZM388.18 399.83C388.3 420.79 388.93 453.03 391.53 464.53C392.26 467.74 392.98 472.03 393.69 476.95L388.18 399.83Z",
    fill: "#C4E9F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.8 312.34C431.8 312.34 440.19 319.05 433.48 338.85C426.77 358.65 424.08 369.39 422.74 369.72C421.4 370.06 414.35 371.4 412 368.71C409.65 366.03 407.64 363.68 407.97 362C408.31 360.32 415.87 317.65 416.69 313.68C418.37 305.63 429.44 311.33 431.79 312.34H431.8Z",
    fill: "#C4E9F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.19 314.02L399.92 308.99L418.04 308.65C418.04 308.65 427.44 309.99 431.46 318.72C432.84 321.72 429.45 365.36 429.11 371.4C428.77 377.44 434.35 380.97 433.27 384.14C427.15 401.98 380.77 389.24 380.77 389.24C380.77 389.24 383.48 319.39 390.19 314.02Z",
    fill: "#C4E9F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.42 313.26C398.42 313.26 403.61 322.67 389.85 338.4C376.09 354.14 369.51 363.04 368.14 362.83C366.77 362.63 359.75 361.18 358.6 357.8C357.45 354.42 356.49 351.48 357.44 350.06C358.39 348.64 384.32 320.14 387.28 317.37C390.24 314.6 396.63 311.43 398.42 313.26Z",
    fill: "#C4E9F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.4 290.86L419.06 308.98C419.06 308.98 419.75 311.5 414.03 312C406.31 312.67 402.96 309.65 402.96 309.65C402.96 309.65 407.32 301.26 406.65 289.85C405.98 278.44 420.41 290.86 420.41 290.86H420.4Z",
    fill: "#F7B68B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.97 256.97C406.97 256.97 416.77 254.62 426.43 262C432.13 266.36 435.49 274.08 432.47 280.46C429.45 286.84 422.74 295.22 419.38 295.22C416.02 295.22 408.64 290.19 407.64 288.17C406.64 286.15 406.63 284.81 405.96 280.45C405.29 276.09 402.94 277.43 402.94 278.44C402.94 279.45 401.6 282.47 400.93 280.45C400.26 278.44 386.5 264.01 406.97 256.96V256.97Z",
    fill: "#243C53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.68 257.98C413.68 265.76 420.22 272.07 428.28 272.07C436.34 272.07 442.88 265.76 442.88 257.98C442.88 250.2 436.34 243.89 428.28 243.89C420.22 243.89 413.68 250.2 413.68 257.98Z",
    fill: "#243C53"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_39_899"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 503.63,
    height: 590,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGaphsPhone);
export default __webpack_public_path__ + "static/media/gaphs_phone.dc0309a5783549bfd395c49f4b4a36b9.svg";
export { ForwardRef as ReactComponent };